<template>
    <div class="card">
        <datatable :tableId="`${sandboxId}-pipelines`" :columns="columns" :formatColumn="formatColumn" :data="jobList"
            :compact="true" :orderColumn="orderColumn" uniqueField="name" :detailColumn="{
                renderBaseUrl: (data) => {
                    return `${data.name}/run-history`;
                },
            }" />
    </div>
</template>

<script>
import Datatable from "../../../components/Datatable.vue";
import { secondsTohms } from '../../../utils/commonFunction';
import { mapActions } from "vuex";
export default {
    components: { Datatable },
    data() {
        return {
            sandboxId: this.$route.params.sandboxId,
            columns: [
                {
                    data: "name",
                    title: "Job Name"
                },
                {
                    data: "kind",
                    title: "Job Kind",
                    render: function (data, type, row) {
                        let jobKind = data;
                        switch (jobKind) {
                            case undefined: jobKind = 'INTERNAL'; break;
                        }
                        //To have this render value in dropdown filter setting valur for type
                        row.kind = jobKind
                        return jobKind
                    },
                },
                {
                    data: "last_run_started_at",
                    title: "Last Run At"
                },
                {
                    data: "last_run_time",
                    title: "Last Run Time",
                    render: function (data, type, row) {
                        return secondsTohms(data)
                    },
                },
                {
                    data: "last_run_status",
                    title: "Last Run Status"
                },
                {
                    data: "created_at",
                    title: "Created"
                },
            ],
            orderColumn: [3, "desc"],
            formatColumn: [
                {
                    index: 3,
                    type: "datetime"
                },
                {
                    index: 6,
                    type: "datetime"
                }
            ],
        }
    },
    props: ["selectedSandbox"],
    computed: {
        jobList() {
            let jobList = [];
            if (this.$store.state.amdp.pipelines) {
                this.$store.state.amdp.pipelines.map((job) => {
                    let status = job.last_run_status ? job.last_run_status.toLowerCase() : '';
                    let statusStr = job.last_run_status;
                    if (status === "succeeded" || status === "completed") {
                        statusStr = "<span class='text-success'>●</span> " + job.last_run_status;
                    } else if (status === "failed") {
                        statusStr = "<span class='text-danger'>●</span> " + job.last_run_status;
                    } else if (status === "running") {
                        statusStr = "<span class='text-primary'>●</span> " + job.last_run_status;
                    } else if (status === "submitted") {
                        statusStr = "<span class='text-warning'>●</span> " + job.last_run_status;
                    } else if (status === "cancelled") {
                        statusStr = "<span class='text-secondary'>●</span> " + job.last_run_status;
                    }
                    job["last_run_status"] = statusStr;
                    jobList.push(job);
                })
            }
            return jobList;
        }
    },
    beforeMount() {
        this.fetchPipelineJobs(this.sandboxId);
    },
    methods: {
        ...mapActions({
            fetchPipelineJobs: "amdp/fetchPipelines",
        }),
    }
}
</script>

<style></style>